import { apiCustomerAdd, apiCustomerCheckCnpj, apiCustomerEdit, getCustomerChannelList } from '@/api/customer';
import { getAddressByZipCode, pageCustomerSender, selectCity, selectState } from '@/api/orderApi';
import { cloneDeep } from 'lodash-es';
import { formatCnpj } from '@/utils/strUtil';
export default {
  removeFile(file, fileList) {
    // 通过 url 匹配删除
    const index = this.fileList.findIndex((item) => item.url === file.url);
    if (index > -1) {
      this.fileList.splice(index, 1);
    }
  },
  handlePreview(file) {
    if (!file.url) {
      this.$message.warning('文件地址无效');
      return;
    }
    // 方式1：新窗口打开图片（适合预览）
    window.open(file.url, '_blank');
  },
  async buildSenderAddressData() {
    const ruleForm = this.ruleForm;
    const customerSender = {
      senderName: ruleForm.company,
      senderMobile: ruleForm.customerPhone,
      senderTax: ruleForm.cnpjMother ? ruleForm.cnpjMother.replace(/\D/g, '') : '',
      senderZipcode: ruleForm.zipcode,
      senderState: ruleForm.state,
      senderCity: ruleForm.city,
      senderArea: '',
      senderStreet: ruleForm.street,
      senderHouseNumber: ruleForm.houseNumber,
      senderIeNumber: ruleForm.ieNumber,
      senderComplement: ruleForm.complement,
      senderMail: ruleForm.customerEmail,
      senderAddress: ruleForm.address
    };
    if (ruleForm.id) {
      customerSender.id = await this.getCustomerSenderId(ruleForm.id);
    }
    return { customerSender };
  },
  getCustomerSenderId(customerId) {
    const params = {
      pageNumber: 1,
      pageSize: 10,
      params: { customerId, senderZipcode: '', senderName: '' }
    };
    return pageCustomerSender(params)
      .then((res) => res.code === 200 && res.data?.records?.length ? res.data.records[0].id : '')
      .catch(() => '');
  },
  async asyncUserAdd(obj) {
    if (this.syncSenderAddress && this.ruleForm.source === 'corporation') {
      Object.assign(obj, await this.buildSenderAddressData());
    }
    apiCustomerAdd(obj)
      .then((res) => {
        if (res.code === 200) {
          this.$message({
            message: this.$t('customerManagements.AddedSuccessfully'), // '添加成功'
            type: 'success'
          });
          setTimeout(() => {
            this.$emit('updataData');
            this.ruleForm.password = '';
          }, 1500);
        }
      })
      .catch(() => {
        this.$message.error(this.$t('sensitiveView.failed'));
      });
  },
  async asyncUserEdit(obj) {
    // 根据需求将账户名称进行置空处理
    const newObj = cloneDeep(obj);
    newObj.username = '';
    newObj.password = '';

    if (this.syncSenderAddress && this.ruleForm.source === 'corporation') {
      Object.assign(obj, await this.buildSenderAddressData());
    }

    apiCustomerEdit(obj)
      .then((res) => {
        if (res.code === 200) {
          this.$message({
            message: this.$t('customerManagements.ModificationSuccessful'), // '修改成功'
            type: 'success'
          });

          setTimeout(() => {
            this.$emit('updataData');
          }, 1500);
        }
      })
      .catch(() => {
        this.$message.error(this.$t('sensitiveView.failed'));
      });
  },
  getLastUploadArr(str) {
    if (!str) {
      return null; // 返回 null 便于后续过滤
    }
    try {
      const newStr = decodeURI(str);
      const URLArr = newStr.split('/');
      const name = URLArr[URLArr.length - 1] || 'unknown';
      return { name, url: str };
    } catch (error) {
      return null;
    }
  },
  setLockState(value) {
    this.dialog.lockVisible = true;
    this.dialog.obj.idList = [this.ruleForm.id];
    this.dialog.obj.type = value;
    this.dialog.obj.status = value;
  },
  resetPwd() {
    this.$emit('resetPwd');
  },
  handleCnpjMother(val) {
    this.ruleForm.cnpjMother = formatCnpj(val);
  },
  checkCnpj(cnpj, id) {
    const data = {
      cnpj: cnpj,
      id: id
    };
    apiCustomerCheckCnpj(data)
      .then((res) => {
        if (res.code !== 200) {
          this.$message.error(res.msg);
        }
      })
      .catch({});
  },
  zipcodeChange(zipcode) {
    if (zipcode && zipcode.length === 8) {
      getAddressByZipCode(zipcode).then((res) => {
        if (res.code === 200) {
          if (res.data.state) {
            this.ruleForm.state = res.data.state;
          }
          if (res.data.city) {
            this.ruleForm.city = res.data.city;
          }
          if (res.data.street) {
            this.ruleForm.street = res.data.street;
          }
          if (res.data.houseNumber) {
            this.ruleForm.houseNumber = res.data.houseNumber;
          }
        }
      });
    }
  },
  getSenderCity(name = '') {
    let id = null;
    this.StateList.map((item) => {
      if (item.shortName === this.ruleForm.state) {
        id = item.id;
      }
    });
    const params = {
      pageNumber: 1,
      pageSize: 200,
      params: {
        id,
        name
      }
    };
    selectCity(params, false).then((res) => {
      if (res.code === 200) {
        this.cityList = res.data.records;
      }
    });
  },
  getAddress() {
    const params = {
      pageNumber: 1,
      pageSize: 200,
      params: {
        name,
        countryName: 'Brazil'
      }
    };
    selectState(params, false).then((res) => {
      if (res.code === 200) {
        this.StateList = res.data.records;
      }
    });
  },
  changeState() {
    this.ruleForm.city = '';
  },
  getChannel() {
    getCustomerChannelList().then((res) => {
      if (res.code === 200) {
        this.channelList = res.data || [];
      }
    });
  }
};
